import { useCallback, useEffect, useState } from "react";
import AmountScreen from "./components/AmountScreen";
import type { CurrencyMode } from "./constants";

export default function Home() {
  const [amount, setAmount] = useState("");
  const [currencyMode, setCurrencyMode] = useState<CurrencyMode>("crypto");

  // Urmărește înălțimea reală vizibilă pe telefon (iOS) ca ecranul să nu
  // lase spațiu gol sub buton când bara browserului se strânge/desface.
  useEffect(() => {
    const update = () => {
      document.documentElement.style.setProperty(
        "--app-height",
        `${window.innerHeight}px`
      );
    };
    update();
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    const viewport = window.visualViewport;
    viewport?.addEventListener("resize", update);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
      viewport?.removeEventListener("resize", update);
    };
  }, []);

  const handleKey = useCallback((key: string) => {
    setAmount((prev) => {
      if (key === ".") {
        return prev.includes(".") ? prev : prev === "" ? "0." : `${prev}.`;
      }
      if (prev === "0") return key;
      const dotIndex = prev.indexOf(".");
      if (dotIndex !== -1 && prev.length - dotIndex > 6) return prev;
      if (prev.length >= 12) return prev;
      return prev + key;
    });
  }, []);

  const handleDelete = useCallback(() => {
    setAmount((prev) => prev.slice(0, -1));
  }, []);

  const handleToggleCurrency = useCallback(() => {
    setCurrencyMode((mode) => (mode === "crypto" ? "usd" : "crypto"));
  }, []);

  return (
    <div className="app-shell w-full bg-background-50 md:bg-background-100 flex items-stretch md:items-center justify-center md:min-h-screen md:p-8 font-sans">
      <div className="relative w-full h-full md:min-h-0 md:w-[420px] md:h-[860px] bg-background-50 overflow-hidden flex flex-col md:rounded-[44px] md:border-[10px] md:border-foreground-950">
        <div className="relative flex-1 min-h-0 overflow-hidden">
          <AmountScreen
            amount={amount}
            currencyMode={currencyMode}
            onKey={handleKey}
            onDelete={handleDelete}
            onToggleCurrency={handleToggleCurrency}
            onBack={() => setAmount("")}
          />
        </div>
      </div>
    </div>
  );
}